export default __webpack_public_path__ + "static/media/teamwork.b8f4677e.svg";